import { Link } from "react-router-dom";
import { ArrowUpRight, Linkedin } from "lucide-react";
import { Reveal, Stagger, Item } from "@/components/site/Reveal";
import { TEAM } from "@/lib/content";

export default function Team() {
  return (
    <div data-testid="team-page" className="pt-32 pb-20">
      <section className="mx-auto max-w-7xl px-6 md:px-12 mesh-bg pb-16">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-nexus-cyan font-bold">
            <Link to="/" className="hover:text-foreground">Home</Link> · Team
          </p>
          <h1 className="mt-5 font-display text-5xl md:text-7xl tracking-tight leading-[0.95] max-w-4xl">
            The people behind the <span className="text-gradient">work</span>.
          </h1>
          <p className="mt-7 text-xl text-zinc-400 max-w-2xl">
            Fifty specialists across engineering, design, AI and strategy. Curious, kind, and
            relentlessly focused on the craft.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-7xl px-6 md:px-12 mt-16">
        <Stagger className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {TEAM.map((m) => (
            <Item key={m.name}>
              <div data-testid={`team-card-${m.name.toLowerCase().replace(/\s+/g, "-")}`} className="group rounded-2xl glass border-white/[0.08] overflow-hidden">
                <div className="aspect-[4/5] overflow-hidden bg-zinc-900">
                  <img src={m.avatar} alt={m.name} className="w-full h-full object-cover transition duration-700 group-hover:scale-105" />
                </div>
                <div className="p-6">
                  <h3 className="font-display text-xl tracking-tight">{m.name}</h3>
                  <p className="text-sm text-nexus-cyan mt-0.5">{m.role}</p>
                  <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{m.bio}</p>
                  <a href="#" aria-label={`${m.name} LinkedIn`} className="mt-4 inline-flex items-center gap-1.5 text-xs text-zinc-500 hover:text-foreground">
                    <Linkedin className="h-3.5 w-3.5" /> LinkedIn
                  </a>
                </div>
              </div>
            </Item>
          ))}
        </Stagger>
      </section>

      <section className="mx-auto max-w-7xl px-6 md:px-12 mt-32">
        <Reveal>
          <div className="rounded-3xl glass border-white/[0.08] p-10 md:p-16 grid md:grid-cols-2 gap-10 items-center">
            <div>
              <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-nexus-cyan font-bold">[ Culture ]</p>
              <h2 className="mt-4 font-display text-3xl md:text-5xl tracking-tight leading-[1.05]">
                Distributed by design. United by craft.
              </h2>
              <p className="mt-5 text-zinc-400 leading-relaxed">
                Quarterly innovation weeks, generous learning budgets, fully remote with optional
                hubs in NYC, Lisbon, and Bengaluru. We hire kind, curious people — and trust them.
              </p>
              <Link to="/contact" className="mt-7 inline-flex items-center gap-1.5 rounded-full bg-nexus-cyan text-nexus-ink font-semibold px-5 py-2.5 text-sm">
                Join the team <ArrowUpRight className="h-4 w-4" />
              </Link>
            </div>
            <div className="aspect-[4/3] rounded-2xl overflow-hidden border border-white/10">
              <img src="https://images.unsplash.com/photo-1629904853716-f0bc54eea481?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzb2Z0d2FyZSUyMGRldmVsb3BtZW50JTIwb2ZmaWNlJTIwZGFya3xlbnwwfHx8fDE3Nzk1NTY0Nzl8MA&ixlib=rb-4.1.0&q=85" alt="Team at work" className="w-full h-full object-cover" />
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
